import * as React from 'react';

const SvgEyePassword = (props) => (
  <svg
    width={16}
    height={16}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#EyePassword_svg__a)' fill='#333132'>
      <path d='M8 10.887a2.888 2.888 0 0 0 0-5.774 2.888 2.888 0 0 0 0 5.774Zm0-4.774A1.89 1.89 0 0 1 9.887 8 1.89 1.89 0 0 1 8 9.887 1.89 1.89 0 0 1 6.113 8 1.89 1.89 0 0 1 8 6.113Z' />
      <path d='M8.001 14.013c2.507 0 4.874-1.466 6.5-4.013.707-1.1.707-2.893 0-4-1.633-2.547-4-4.013-6.5-4.013S3.135 3.453 1.508 6C.8 7.1.8 8.893 1.508 10 3.135 12.547 5.5 14.013 8 14.013Zm0-11.026c2.154 0 4.214 1.293 5.654 3.553.5.78.5 2.14 0 2.92-1.44 2.26-3.5 3.553-5.654 3.553-2.153 0-4.213-1.293-5.653-3.553-.5-.78-.5-2.14 0-2.92C3.788 4.28 5.848 2.987 8 2.987Z' />
    </g>
    <defs>
      <clipPath id='EyePassword_svg__a'>
        <path fill='#fff' transform='matrix(-1 0 0 1 16 0)' d='M0 0h16v16H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgEyePassword;
